export enum EventTypeEnum {
   COMMENT = 'COMMENT',
    WEIGHING = 'WEIGHING',
    REFUELING = 'REFUELING',
    JOBINFO = 'JOBINFO',
    WEATHER = 'WEATHER',
    CUSTOMER = 'CUSTOMER',
    JOB_START = 'JOB_START',
    JOB_STOP = 'JOB_STOP',
    JOB_PAUSE = 'JOB_PAUSE',
    JOB_RESUME = 'JOB_RESUME',
    EMPLOYEE_WORK_START = 'EMPL_W_START',
	EMPLOYEE_WORK_STOP = 'EMPL_W_STOP',
	EMPLOYEE_PAUSE_START = 'EMPL_P_START',
	EMPLOYEE_PAUSE_STOP = 'EMPL_P_STOP',
	EMPLOYEE_ENTERED_MACHINE = 'EMPL_E_MACH',
	EMPLOYEE_LEFT_MACHINE = 'EMPL_L_MACH',
	EMPLOYEE_COUPLED_IMPLEMENT = 'EMPL_C_IMPL',
	EMPLOYEE_UNCOUPLED_IMPLEMENT = 'EMPL_UC_IMPL',
	EMPLOYEE_ENTERED_FIELD = 'EMPL_E_FIELD',
	EMPLOYEE_LEFT_FIELD = 'EMPL_L_FIELD',
	LOADED_IMPLEMENT = 'L_IMPL',
	UNLOADED_IMPLEMENT = 'UL_IMPL',
	COUNTER = 'CT',
	COUNTER_RESET = 'CT_RS',
	T2_ONLINE = 'T2_ON',
	GRAIN_TANK_OVER_70 = 'GTO70',
}
